module.exports = __webpack_public_path__ + "static/media/Lock-white.71e0fd29.svg";